/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface PaysSearch
 */
export interface PaysSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof PaysSearch
     */
    pays?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PaysSearch
     */
    codePays?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof PaysSearch
     */
    europe?: BooleanSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof PaysSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaysSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PaysSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PaysSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaysSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PaysSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PaysSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PaysSearch interface.
 */
export function instanceOfPaysSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaysSearchFromJSON(json: any): PaysSearch {
    return PaysSearchFromJSONTyped(json, false);
}

export function PaysSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaysSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pays': !exists(json, 'pays') ? undefined : TextSearchFromJSON(json['pays']),
        'codePays': !exists(json, 'codePays') ? undefined : TextSearchFromJSON(json['codePays']),
        'europe': !exists(json, 'europe') ? undefined : BooleanSearchFromJSON(json['europe']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PaysSearchToJSON(value?: PaysSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pays': TextSearchToJSON(value.pays),
        'codePays': TextSearchToJSON(value.codePays),
        'europe': BooleanSearchToJSON(value.europe),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

